import React, { useState, useEffect, useRef } from 'react';
import {
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
  DropdownToggle
} from "reactstrap";

const Dropdown = (props) => {
  const [dropdownOpen, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');

  const autoSelectedRef = useRef(false);

  const headername = props?.config?.renamed_block_parameter || '';
  const defaultValue = 'Please select ' + headername;
  const options = props?.config?.parameter_options || [];
  const parameterValue = props?.config?.parameter_value;

  useEffect(() => {
    if (parameterValue) {
      setSelectedValue(parameterValue);
      return;
    }

    if (options.length === 1) {
      const firstOption = options[0];

      setSelectedValue(firstOption);

      if (!autoSelectedRef.current) {
        autoSelectedRef.current = true;
        props.handleInput?.(firstOption);
        props.handleGenFormInput?.(firstOption);
      }

      return;
    }

    setSelectedValue(defaultValue);
  }, [parameterValue, options, defaultValue]);

  const selectDropdown = (val) => {
    setSelectedValue(val);
    props.handleInput?.(val);
    props.handleGenFormInput?.(val);
  };

  return (
    <div className='petdropdown genericpet-petdropdown'>
      {props?.showLabel && (
        <label className='label-text'>
          {props?.config?.renamed_block_parameter}
          {props?.ifRequired && <sup>*</sup>}
        </label>
      )}

      <ButtonDropdown
        data-testid="dropdownItem"
        toggle={() => setOpen(!dropdownOpen)}
        isOpen={dropdownOpen}
      >
        <DropdownToggle
          disabled={props?.isDisabled || props?.disabled}
          className=""
          caret
          style={{
            backgroundColor: props?.formcolor || 'rgba(5, 138, 238, 0.1)',
            border: "none"
          }}
        >
          {selectedValue}
        </DropdownToggle>

        <DropdownMenu
          style={{
            backgroundColor: props?.formcolor || 'rgba(5, 138, 238, 0.1)',
            border: "none"
          }}
          className="generic-petdropdownitems-main"
        >
          {options.map((data) => (
            <DropdownItem
              data-testid="petdropdownItem"
              key={data}
              active={String(selectedValue) === String(data)}
              onClick={() => selectDropdown(data)}
              className="generic-petdropdownitems"
            >
              {data}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </ButtonDropdown>
    </div>
  );
};

Dropdown.propTypes = {};

export default Dropdown;